import { useEffect, useState } from "react";

// TES-1233 — a clock that re-renders its reader: the countdown to the next
// meeting, the calendar's now-line and the "has started" warning all move
// with time, not only when the 30-second data poll lands.
export function useNow(intervalMs = 15_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
